// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"6b410618","879":"29f843e7","8065":"7f034425"}[chunkId] + ".chunk.css";
};